import { Button } from 'antd';
import * as React from 'react';

import { ArithmeticalOperatorSymbol } from 'stores/models';

import s from './OperationTag.module.scss';
import { TEXT_MAPPER } from './texts';

type OperationTagProps = {
  operator: ArithmeticalOperatorSymbol;
  onSelect: (operation: ArithmeticalOperatorSymbol) => void;
};

/** Компонент кнопки с арифметической операцией для формулы*/
const OperationTag: React.FC<OperationTagProps> = ({ operator, onSelect }) => {
  const handleClick = React.useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      onSelect(operator);
    },
    [operator, onSelect]
  );

  return (
    <Button onClick={handleClick} type="ghost">
      <span className={s.sybmol}>{operator}</span>
      {TEXT_MAPPER[operator]}
    </Button>
  );
};

export default React.memo(OperationTag);
